import { createSlice, current } from '@reduxjs/toolkit'

const defaultPlanogramImageState = {
  originalImage: {
    colors: {}
  },
  virtualImage: {
    activeAnalysisTab: "png",
    oosData: [],
    analysis: {
      png: {
        options: {
          default: {
            color: 'rgba(0, 255, 179, 1)',
          },
          shelf: {
            color: 'rgba(50, 50, 50, 0.875)',
          },
          customer: {
            color: 'rgba(80, 227, 194, 0.5)',
          },
          competition: {
            color: 'rgba(255, 0, 27, 0.5)'
          }
        },
      },
      brands: {
        currentSelectedType: "brands",
        brands: [],
        skus: [],
        selectedBrands: [],
        selectedSkus: [],
        colors: {}
      }
    }
  },
  regeneratedImage: {
    colors: {}
  }
}

export const planogramImageSlice = createSlice({
  name: 'planogramImage',
  initialState: {
    ...defaultPlanogramImageState
  },
  reducers: {
    setOosData(state, action) {
      const data = action.payload;
      state.virtualImage.oosData = data;
    },
    updateVirtualImagePngTypeColor(state, action) {
      const { imageType, skuType, color } = action.payload;
      state[imageType]["analysis"]["png"]["options"][skuType]["color"] = color;
    },
    changeActiveAnalysisTab(state, action) {
      const { type, tab } = action.payload;
      state[type]["activeAnalysisTab"] = tab;
    },
    setBrandOptions(state, action) {
      const { brands, skus } = action.payload;
      state.virtualImage.analysis.brands.brands = brands;
      state.virtualImage.analysis.brands.skus = skus;
    },
    setSelectedBrandOptions(state, action) {
      const { type, values } = action.payload;

      if (type === "brands") {
        state.virtualImage.analysis.brands.selectedBrands = values;
        state.virtualImage.analysis.brands.selectedSkus = [];
        state.virtualImage.analysis.brands.currentSelectedType = "brands";
        values.map(r => {
          if (r in state.virtualImage.analysis.brands.colors) {

          } else {
            state.virtualImage.analysis.brands.colors[r] = "rgba(0, 255, 179, 1)";
          }
        })
      } else if (type === "skus") {
        state.virtualImage.analysis.brands.selectedSkus = values;
        state.virtualImage.analysis.brands.selectedBrands = [];
        state.virtualImage.analysis.brands.currentSelectedType = "skus";
        values.map(r => {
          if (r in state.virtualImage.analysis.brands.colors) {

          } else {
            state.virtualImage.analysis.brands.colors[r] = "rgba(0, 255, 179, 1)";
          }
        })
      }
    },
    updateVirtualImageBrandTypeColor(state, action) {
      const { imageType, type, color } = action.payload;
      state.virtualImage.analysis.brands.colors[type] = color;
    },
    handleRemoveBrandOption(state, action) {
      const { type, item } = action.payload;
      let updatedState = { ...state };

      // removing colors
      let colors = updatedState.virtualImage.analysis.brands.colors;
      delete colors[item];
      state.virtualImage.analysis.brands.colors = colors;

      // removing selected items
      if (type === "brands") {
        const currentSelectedBrands = state.virtualImage.analysis.brands.selectedBrands;
        state.virtualImage.analysis.brands.selectedBrands = currentSelectedBrands.filter(r => r !== item);
      } else if (type === "skus") {
        const currentSelectedSkus = state.virtualImage.analysis.brands.selectedSkus;
        state.virtualImage.analysis.brands.selectedSkus = currentSelectedSkus.filter(r => r !== item);
      }
    }
  }
})
